import type { ItemNoun } from '../../types';

export const DEFAULT_ITEM_NOUN: ItemNoun = {
  singular: 'item',
  plural: 'items'
};
